import "./sheet-card";

import { Storybook } from "@tento-ui/ui/storybook";
import { GridIcon, LonaIcons } from "@tento-ui/ui/icons";
import { NuxSheetCard } from "./sheet-card";
import { $makeHomeCard } from "@tento-ui/components/home-card/home-grid-card.example";
import { Tracing } from "@tento-core/tracing";

const exampleCallbacks: NuxSheetCard.Callbacks = {
  onShowNullstate: () => Tracing.dev("storybook", "Show nullstate clicked"),
  onSelectTemplate: (id) => Tracing.dev("storybook", "Template selected:", id),
};

export class NuxSheetCardStoryBook extends Storybook.Default {
  title(): string {
    return "Nux Sheet Card";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "In Context",
        render: () =>
          $makeHomeCard({
            title: "Create a Sheet",
            icon: LonaIcons.$template(GridIcon),
            contentBg: "var(--bg-surface-light-opaque)",
            $cardContent: NuxSheetCard.makeWith(exampleCallbacks),
          }),
      },
      {
        title: "Raw",
        render: () => NuxSheetCard.makeWith(exampleCallbacks),
      },
    ];
  }
}
